/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Plugin } from 'ckeditor5';
import { uniqueId } from 'lodash';

export class CommentsIntegration extends Plugin {
	public static get requires() {
		return [ 'CommentsRepository' ] as const;
	}

	public static get pluginName() {
		return 'CommentsIntegration' as const;
	}

	public init(): void {
		const commentsRepositoryPlugin = this.editor.plugins.get( 'CommentsRepository' );

		commentsRepositoryPlugin.adapter = {
			addComment: () => Promise.resolve( {
				commentId: uniqueId(),
				createdAt: new Date()
			} ),

			updateComment: () => Promise.resolve(),

			removeComment: () => Promise.resolve(),

			getCommentThread: () => {
				const initialCommentThreadData = {
					threadId: 'thread-1',
					attributes: {},
					comments: [
						{
							commentId: uniqueId(),
							authorId: 'user-1',
							attributes: {},
							content: '<p>Are we sure we want phrase it like this?</p>',
							createdAt: new Date()
						},
						{
							commentId: uniqueId(),
							authorId: 'user-2',
							attributes: {},
							content: '<p>I believe it was <span class="mention" data-mention="@Olivia">@Olivia</span>\'s decision...</p>',
							createdAt: new Date()
						}
					]
				};

				return Promise.resolve( initialCommentThreadData );
			},

			addCommentThread: () => Promise.resolve( {
				threadId: uniqueId(),
				comments: []
			} ),

			resolveCommentThread: () => Promise.resolve( {
				threadId: uniqueId(),
				resolvedAt: new Date(),
				resolvedBy: 'user-1'
			} ),

			updateCommentThread: () => Promise.resolve(),

			reopenCommentThread: () => Promise.resolve(),

			removeCommentThread: () => Promise.resolve()
		};
	}
}
